import styles from "./index.module.css";
import { useGetPartnerDocumentListQuery } from "../../services/api";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import Select, { SingleValue } from "react-select";
import PartnerDocumentCard from "./PartnerDocumentCard";



const PartnerDocumentTile = (props: PartnerDocumentTileProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { data, isLoading } = useGetPartnerDocumentListQuery({ page: currentPage, limit });
  const heading = props?.heading || "Partner Documents";

  const getDocUrl = (item: PartnerDocument) => {
    return item.fileUrl || item.linkUrl;
  };

  const fetchFile = (item: PartnerDocument) => {
    const url = getDocUrl(item);
    if (url) {
      window.open(url, "_blank");
    }
  };

  const downloadDocument = (item: PartnerDocument) => {
    const url = getDocUrl(item);
    if (url) {
      window.open(url, "_blank");
    }
  };

  const handlePageChange = (selectedItem: { selected: number }) => {
    setCurrentPage(selectedItem.selected + 1);
  };

  const handleLimitChange = (selectedOption: SingleValue<LimitOption>) => {
    if (selectedOption) {
      setLimit(selectedOption.value);
      setCurrentPage(1); // Reset to first page when limit changes
    }
  };

  const limitOptions: LimitOption[] = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
  ];

  const partnerFiles: PartnerDocument[] = data?.data?.data || [];
  const totalCount: number = data?.data?.total || 0;
  const totalPages: number = data?.data?.totalPages || 0;

  return (
    <div className={`${styles.content} `}>
      <div className="w-[90%] mx-auto h-full ">
        <h2 className="mb-5 text-2xl">{heading}</h2>
        <div className="bg-white w-full p-3 md:p-5 rounded-lg shadow-sm">
          <div className="flex justify-between mb-2">
            <div className="w-[70%] items-start m-auto">
              <span className="font-semibold">Name</span>
            </div>
            <div className="w-[30%] items-start text-center">
              <span className="font-semibold">Action</span>
            </div>
          </div>

          <div className="min-h-[400px]">
            {isLoading ? (
              <div className="flex flex-col gap-2">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className={styles.skeletonItem} />
                ))}
              </div>
            ) : (
              <PartnerDocumentCard
                documents={partnerFiles}
                handleView={fetchFile}
                downloadDocument={downloadDocument}
              />
            )}
          </div>

          {!isLoading && totalCount > 0 && (
            <div className="flex flex-col sm:flex-row justify-between items-center mt-6 gap-4">
              <div className="order-2 sm:order-1">
                <ReactPaginate
                  breakLabel="..."
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  pageCount={totalPages}
                  onPageChange={handlePageChange}
                  forcePage={currentPage - 1}
                  renderOnZeroPageCount={null}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={1}
                  previousLinkClassName={styles.previousClass}
                  nextLinkClassName={styles.nextClass}
                  containerClassName={styles.pagination}
                  activeClassName={styles.active}
                />
              </div>
              <div className="flex items-center gap-2 order-1 sm:order-2">
                <span className="text-sm text-gray-600">Page per item:</span>
                <div className="w-[80px]">
                  <Select
                    value={limitOptions.find((opt) => opt.value === limit)}
                    onChange={handleLimitChange}
                    options={limitOptions}
                    isSearchable={false}
                    menuPlacement="top"
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "36px",
                        height: "36px",
                        fontSize: "14px",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 6px",
                      }),
                      input: (base) => ({
                        ...base,
                        margin: "0",
                        padding: "0",
                      }),
                      indicatorSeparator: () => ({
                        display: "none",
                      }),
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PartnerDocumentTile;
